import script from "./Brightness.vue?vue&type=script&setup=true&lang=js"
export * from "./Brightness.vue?vue&type=script&setup=true&lang=js"

import "./Brightness.vue?vue&type=style&index=0&id=3f428dbe&lang=css"

const __exports__ = script;

export default __exports__